import { Image, Text } from 'platform-components';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import './class__empty.scss';

export const Empty = ({ intl }) => {
    return (
        <div className="class__empty">
            <Image
                alt={intl.formatMessage({ id: 'classes.empty.addClass' })}
                className="class__empty-img"
                src={intl.formatMessage({ id: 'classes.empty.img' })}
            />
            <div className="class__empty-title">
                <Text id="classes.empty.addClass" size={Text.SIZE.XXL} weight={Text.WEIGHT.M} />
            </div>
            <div className="class__empty-description">
                <Text id="classes.empty.addClass.description" size={Text.SIZE.XL} />
            </div>
        </div>
    );
};

Empty.propTypes = {
    intl: PropTypes.object.isRequired,
};

export default injectIntl(Empty);
